const PARTNERS = [
  { name: "AyakTakip", image: "/upload/partners/ayaktakip.png", href: "https://ayaktakip.com/", desc: "Ayak sağlığı takip iOS uygulaması" },
  { name: "Pedizone", image: "/upload/partners/pedizone.png", href: "https://pedizone.com/", desc: "Dermokozmetik ayak bakım ürünleri" },
  { name: "Medipodo", image: "/upload/partners/medipodo.png", href: "https://medipodo.com/", desc: "Ankara podoloji merkezi" },
  { name: "MediEste", image: "/upload/partners/medieste.png", href: "https://www.medieste.com/", desc: "Sağlıklı güzellik çözümleri" },
  { name: "Trendyol", image: "/upload/partners/trendyol.png", href: "https://www.trendyol.com/magaza/medipodo-m-1114633", desc: "Online satış platformu" },
  { name: "Hepsiburada", image: "/upload/partners/hepsiburada.png", href: "https://www.hepsiburada.com/magaza/medipodo", desc: "Online satış platformu" },
  { name: "Ortomek", image: "/upload/partners/ortomek.png", href: "#", desc: "Kişiye özel tabanlık çözümleri" },
  { name: "Amazon", image: "/upload/partners/amazon.png", href: "https://www.amazon.com.tr/s?k=pedizone", desc: "Online satış platformu" },
];

export default function Partners({ compact = false }) {
  return (
    <section data-testid="partners-section" className={`${compact ? "py-16" : "py-24 md:py-32"} bg-white border-t border-[#E5EAF0]`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 max-w-3xl mx-auto">
          <p className="chip mb-4 mx-auto">İş Ortaklarımız</p>
          <h2 className="font-display text-3xl md:text-5xl text-[#0B1B33] leading-[1.1] tracking-tight mb-5">
            İş Ortaklarımız &amp; Çözüm Ağımız
          </h2>
          <p className="text-[#4B5A6E] leading-relaxed">
            MediEste olarak güzellik ve ayak sağlığı hizmetlerimizi geliştirirken, farklı alanlarda uzmanlaşmış çözüm ortakları ile birlikte çalışıyoruz. Kullandığımız sistemler, ürünler ve destek platformları; misafirlerimize daha kapsamlı ve güvenilir bir deneyim sunmamıza yardımcı olur.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {PARTNERS.map((p) => {
            const Tag = p.href && p.href !== "#" ? "a" : "div";
            return (
              <Tag
                key={p.name}
                {...(Tag === "a" ? { href: p.href, target: "_blank", rel: "noreferrer" } : {})}
                data-testid={`partner-${p.name.toLowerCase()}`}
                className="group bg-white border border-[#E5EAF0] rounded-2xl p-6 md:p-8 flex flex-col items-center justify-center text-center hover:border-[#10B981]/40 hover:shadow-lg transition-all"
                style={{ minHeight: 190 }}
              >
                <div className="h-16 md:h-20 flex items-center justify-center mb-4 w-full">
                  <img
                    src={p.image}
                    alt={p.name}
                    loading="lazy"
                    className="max-h-full max-w-[85%] object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <p className="font-display font-semibold text-[#0B1B33] text-base md:text-lg mb-1">{p.name}</p>
                <p className="text-xs text-[#7C8CA0] leading-snug">{p.desc}</p>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
}
